import React from "react";

const Logo: React.FC<LogoProps> = ({ onClick }) => {
  return (
    <img
      role="button"
      aria-label="Logo button"
      onClick={onClick}
      className="cursor-pointer max-sm:h-5"
      src={
        "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/66a3ea54-9b63-4866-fa02-a1e7240c3700/public"
      }
      draggable={false}
    />
  );
};

export default Logo;
